'use client';

import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import { Flex, Icon, Text, Separator } from '@/_components';
import { Fragment, useContext, type FC } from 'react';
import { FirmRoleItem } from './_components/FirmRoleItem';
import type { FirmRolePillsProps } from './FirmRolePills.types';
import styles from './FirmRolePills.module.css';

export const FirmRolePills: FC<FirmRolePillsProps> = ({
  company,
  isEditing,
}) => {
  const { firmRoles } = useContext(FirmSettingsContext);

  const hasCompanyId: boolean = typeof company?.id === 'number';

  if (!hasCompanyId) return null;

  if (!firmRoles?.length) {
    return (
      <Flex isYCentered={true} gap={2}>
        <Icon name="shield-slash" size={16} color="secondary" />
        <Text type="small" color="secondary">
          No firm roles have been created yet
        </Text>
      </Flex>
    );
  }

  return (
    <Flex isColumn={true} isFullWidth={true} className={styles.firmRolePills}>
      {firmRoles?.map((firmRole, key) => {
        const isLast: boolean = key === firmRoles.length - 1;

        return (
          <Fragment key={key}>
            <FirmRoleItem
              firmRole={firmRole}
              isEditing={!!isEditing}
              company={company}
            />
            {!isLast && <Separator isLight={true} />}
          </Fragment>
        );
      })}
    </Flex>
  );
};
